// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"355":"191a9408","385":"22438895","633":"85e01b39","692":"1f7f5ea3","709":"04c0613b"}[chunkId] + ".chunk.js";
};